import { useMemo, useReducer, useCallback, useEffect } from "react";
import { Card } from "./card";

//@ts-ignore
import { Preview } from 'react-dnd-preview'

type Props = {
    onComplete?: () => void,
    data: string[],
    id: string
}

type Item = {
    id: string,
    description: string,
    correct: number
}

type GameState = {
    items: Item[]
}

const Task302Game: React.FC<Props> = ({ onComplete, data, id }) => {

    const initData: GameState = useMemo(() => {
        return {
            items: data.map((text, index) => {
                return {
                    id: `${id}_${index}`,
                    description: text,
                    correct: index
                }
            }).sort(_ => Math.random() - .5)
        }

    }, [data, id])



    const [state, itemMove] = useReducer((state: GameState, { dragIndex, hoverIndex }: { dragIndex: number, hoverIndex: number }) => {
        const copyArr = [...state.items];
        copyArr.splice(hoverIndex, 0, copyArr.splice(dragIndex, 1)[0]);

        return {
            ...state,
            items: [...copyArr]
        }
    }, initData)

    const moveCard = useCallback((dragIndex: number, hoverIndex: number) => {
        itemMove({ dragIndex, hoverIndex })
    }, [])

    useEffect(() => {
        const complete = state.items.reduce((prev, next, index) => {
            return prev && next.correct === index;
        }, true)

        if (complete) {
            if (onComplete) {
                onComplete();
            }
        }
    }, [state, onComplete])

    return <div className="task-302-game">
        <div className={`items`}>
            {
                state.items.map((item, index) => {

                    // const item = state.items.find(i => i.id === s.itemId);

                    if (item) {
                        return <div className={`item`} key={index}>
                            <Card type={id} id={item.id} index={index} moveCard={moveCard} data={item} >
                                <GameItem item={item} correct={index === item.correct} />
                            </Card>
                        </div>
                    }

                    return <></>

                })
            }
        </div>

        <ItemPreview />
    </div>
}

const GameItem: React.FC<{
    item: Item,
    correct?: true | false | null
}> = ({ item, correct }) => {
    return <div className={`task-302-pick-up ${correct === true ? 'correct' : (correct === false ? 'wrong' : '')}`}>
        <div className="description">
            {item.description}
        </div>
    </div>
}

const ItemPreview: React.FC<{}> = () => {
    return <Preview>{({ item, style }: any) => {
        return <div style={{ ...style, width: item.size.width }}>
            <GameItem item={item.data} />
        </div>
    }}</Preview>
}

export default Task302Game;
